<template>
  <section role="region" class="contact-partners-section">
    <h3 class="about-partners">Sobre os nossos parceiros</h3>
    <v-row class="creditors" no-gutters>
      <div class="creditor-block" v-for="(creditor, index) in creditors" :key="creditor.name + index">
        <NuxtLink class="creditor-name" :to="`credor/${creditor.alias}#ajuda`">{{ creditor.name }}</NuxtLink>
      </div>
    </v-row>
  </section>
</template>

<script setup lang="ts">
import { VRow } from 'vuetify/components'
import { usePartnersStore } from '@/stores/home/partners'

const props = defineProps(['partnerName'])

const store = usePartnersStore();
const creditors = store.getPartners.filter(partner => partner.name != props.partnerName);

</script>

<style lang="scss">
@use "@/styles/variables" as *;

.contact-partners-section {
  padding-bottom: 48px;

  .about-partners {
    margin: 18px auto 20px;
    text-align: center;
  }

  .creditors {
    display: grid;

    justify-items: center;
    align-items: center;
    justify-content: center;
    grid-template-columns: auto auto;
    column-gap: 15.62px;
    row-gap: 16px;

    .creditor-name {
      background-color: $white;
      border: 1px solid #DADADA;
      box-shadow: 0px 4px 2px 0px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      min-width: 152px;
      min-height: 68px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $greyDark;
      font-weight: 600;

      &:hover {
        border: 1px solid $blue;
        box-shadow: 0px 4px 2px 0px rgba(0, 0, 0, 0.05);
        color: $blue;
      }
    }
  }

  @media screen and (min-width: 834px) and (max-width: 1200px) {
    padding-bottom: 71px;

    .creditors .creditor-name {
      width: 170px;
      height: 88px;
    }
  }

  @media screen and (min-width: 834px) {
    .about-partners {
      margin: 20px auto 30px;
    }

    .creditors {
      grid-template-columns: repeat(4, auto);
      column-gap: 30px;
    }
  }

  @media screen and (min-width: 1200px) {
    padding-bottom: 68px;

    .creditors .creditor-name {
      width: 270px;
      height: 120px;
    }

  }

}
</style>1